import { useEffect } from 'react'

import throttle from 'lodash/throttle'

/**
 * 1. Excecute onScroll function with throttle
 * 2. Cancel function execution if component already unmounted
 *
 *
 * Usage example:
 *
 * useThrottledScroll(() => {
 *     let scrollTop = document.documentElement.scrollTop || 0
 *
 *     return (scrollEvent) => setScrollTop(document.documentElement.scrollTop)
 * })
 *
 **/

export default function useThrottledScroll(
    wrapperFn: () => (scrollEvent: any) => void,
    dependencies = [],
) {
    useEffect(() => {
        let componentUnmounted = false
        /**
         * Since throttledFn is excecuted within useEffect,
         * `document` and `window` objects are bound to exist
         **/
        const throttledFn = wrapperFn()
        const throttledHandleScroll = throttle((scrollEvent) => {
            if (!componentUnmounted) throttledFn(scrollEvent)
        }, 150)

        window.addEventListener('scroll', throttledHandleScroll)
        return () => {
            window.removeEventListener('scroll', throttledHandleScroll)
            componentUnmounted = true
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, dependencies)
}
